import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const Results = ({ session }) => {
  // 1. Create a state to store the search text
  const [searchTerm, setSearchTerm] = useState("");
  const [isPaidUser, setIsPaidUser] = useState(false);

  useEffect(() => {
    if (!session) {
      setIsPaidUser(false);
      return;
    }
    const checkStatus = async () => {
      const { data } = await supabase
        .from('race_participants')
        .select('*')
        .eq('id', session.user.id)
        .single();
      if (data && data.is_paid) {
        setIsPaidUser(true);
      }
    };
    checkStatus();
  }, [session]);

  let activeRaceData = [
    { position: 1, boatName: "Blue Marlin", skipper: "Capt. Sarah", class: "Laser", points: 1.0 },
    { position: 2, boatName: "Wind Dancer", skipper: "James Hook", class: "Laser", points: 2.0 },
    { position: 3, boatName: "Sea Biscuit", skipper: "Elena Rigby", class: "Optimist", points: 3.0 },
    { position: 4, boatName: "Storm Petrel", skipper: "Jack Sparrow", class: "Finn", points: 4.0 },
  ];

  if (session && isPaidUser && session.user?.user_metadata) {
    activeRaceData.push({
      position: "TBD",
      boatName: session.user.user_metadata.boat_name || "New Entry",
      skipper: session.user.user_metadata.skipper_name || "New Entry",
      class: "Unclassified",
      points: 0.0
    });
  }

  // 2. Filter the list BEFORE we map it
  const filteredResults = activeRaceData.filter((item) =>
    item.boatName.toLowerCase().includes(searchTerm.toLowerCase()) || 
    item.skipper.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="results-section">
      <h3>Race Results</h3>

      {/* 3. The Search Input */}
      <input
        type="text"
        placeholder="Search boat name..."
        className="search-input"
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="table-wrapper">
        <table className="results-table">
          <thead>
            <tr>
              <th>Pos</th>
              <th>Boat Name</th>
              <th>Skipper</th>
              <th>Class</th>
              <th>Points</th>
            </tr>
          </thead>
          <tbody>
            {/* 4. Map over the FILTERED list */}
            {filteredResults.map((result, index) => (
              <tr key={index} className={result.position === 1 ? "winner-row" : ""}>
                <td>{result.position}</td>
                <td><strong>{result.boatName}</strong></td>
                <td>{result.skipper}</td>
                <td>{result.class}</td>
                <td>{result.points}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Show a message if no boats match the search */}
        {filteredResults.length === 0 && (
          <p style={{ textAlign: 'center', padding: '20px' }}>No boats found matching "{searchTerm}"</p>
        )}
      </div>
    </div>
  );
};

export default Results;
